import React from 'react'
import { Typography } from '@mui/material'
import AiCard from './cardKit/AiCard'
import { formatInquiryRupee, type AccountFundsInquiry } from './domains/tradingDomain'

type Props = {
    inquiry: AccountFundsInquiry
}

export default function AccountFundsInquiryCard({ inquiry }: Props) {
    const account = inquiry.account
    if (inquiry.outcome !== 'MATCHED' || !account) {
        return null
    }
    const marginAvailable =
        account.marginAvailable != null ? formatInquiryRupee(account.marginAvailable) : null
    const marginUsed = account.marginUsed != null ? formatInquiryRupee(account.marginUsed) : null
    const cashAvailable = account.cashAvailable != null ? formatInquiryRupee(account.cashAvailable) : null

    return (
        <AiCard accent="neutral">
            <Typography variant="subtitle2" fontWeight={700}>
                {account.accountLabel || 'Trading account'}
            </Typography>
            {marginAvailable != null ? (
                <Typography variant="h6" fontWeight={700} sx={{ mt: 1 }} className="font-feature-num">
                    {marginAvailable}
                    <Typography component="span" variant="body2" color="text.secondary" fontWeight={400} sx={{ ml: 0.75 }}>
                        available
                    </Typography>
                </Typography>
            ) : null}
            {marginUsed != null ? (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }} className="font-feature-num">
                    {marginUsed} used
                </Typography>
            ) : null}
            {cashAvailable != null ? (
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.35 }} className="font-feature-num">
                    Cash {cashAvailable}
                </Typography>
            ) : null}
        </AiCard>
    )
}
